import type { DocNode } from '@atlaskit/adf-schema/doc';

export const CENTRAL_PAGE_EXCERPT_LIMIT = 12_000;

type AdfNode = {
	type?: string;
	text?: string;
	content?: AdfNode[];
};

const BLOCK_CONTAINERS = new Set(['doc', 'bulletList', 'orderedList', 'blockquote']);

const readNode = (node: AdfNode | undefined): string => {
	if (!node) {
		return '';
	}
	if (typeof node.text === 'string') {
		return node.text;
	}
	if (!Array.isArray(node.content)) {
		return '';
	}

	const parts: string[] = [];
	for (const child of node.content) {
		// ADF documents are bounded trees; this walk is linear in node count.
		// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
		const text = readNode(child);
		if (text) {
			parts.push(text);
		}
	}
	const joiner = node.type && BLOCK_CONTAINERS.has(node.type) ? '\n' : '';
	return parts.join(joiner);
};

/**
 * Pulls readable text from the page ADF so cc-smarts has central-page context.
 * The wire contract calls this markdown; newlines between blocks are enough for v1.
 */
export const extractAdfExcerpt = (
	adf: DocNode,
	limit: number = CENTRAL_PAGE_EXCERPT_LIMIT,
): { excerpt: string; truncated: boolean } => {
	const text = readNode(adf as AdfNode).trim();
	return {
		excerpt: text.slice(0, limit),
		truncated: text.length > limit,
	};
};
